export default {
  404: '404',
  register: 'Registre',
  login: 'Se connecter',
  grand: 'Grandiose',
  major: 'Majeur',
  minor: 'Mineure',
  mini: 'Mini',
  crashGameTitle: 'Accident',
  betAmount: 'Montant du pari',
  profit: 'Profit',
  payout: 'Paiement cible',
  chance: 'Chance de gagner',
  betBtn: 'Pari',
  autoCashout: 'Retrait automatique',
  btnHalf: '½',
  btnDouble: '2×',
  btnMax: 'Max.',
  wagered: 'Parié',
  lost: 'Perdu',
  won: 'Gagné',
  gameHotkeys: 'Raccourcis clavier',
  gameInfo: 'Informations sur le jeu',
  gameLiveStats: 'Statistiques en direct',
  gameLoses: 'Pertes',
  gameResult: 'Résultat',
  streak: 'Traînée',
  detailsText: 'Détails',
  highestWin: 'Gain le plus élevé',
  highestLost: 'Le plus haut perdu',
  highestBet: 'Pari le plus élevé',
  maxStreak: 'Série maximale',
  maxProfit: 'Bénéfice maximum : ',
  bal: 'Bal : ',
  controls: 'Contrôles',
  leaderBoard: 'Tableau des leaders',
  yourBet: 'Votre pari',
  messagesNoBetHistory: "L'historique de vos paris est vide",
  messagesCopyNotSupported: 'Votre navigateur ne prend pas en charge la copie automatique dans le presse-papiers.',
  messagesCopied: 'Adresse copiée.',
  deposit: 'Dépôt',
  withdraw: 'Retirer',
  depositHistory: 'Historique des dépôts',
  withdrawalHistory: 'Historique des retraits',
  statReset: 'Réinitialiser les statistiques',
  rollOver: 'Rouler sur',
  inputFieldBtnHalf: '½',
  inputFieldBtnDouble: '2×',
  inputFieldBtnMax: 'Max.',
  buttonTextPlaceBet: 'Placer un pari',
  buttonTextCancelBet: 'Annuler le pari',
  maxBetText: 'Pari maximum',
  buttonTextEscapeBet: 'Retrait',
  buttonTextStartAutoBet: 'Démarrer le pari automatique',
  buttonTextCancelAutoBet: 'Annuler le pari automatique',
  buttonTextLoading: 'Chargement',
  tabsMyBets: 'Mes paris',
  tabsDeposit: 'Dépôt',
  tabsCashout: 'Retraits',
  tabsAllbets: 'Tous les paris',
  tabsTopbets: 'Meilleurs paris',
  tabsBonus: 'Prime',
  tabsjackpot: 'Cagnotte',
  tabsBetHistory: 'Historique des paris',
  timerTextCurrentPayout: 'Paiement actuel',
  timerTextStarting: 'À partir de',
  timerTextSec: 's',
  timerTextFlewAway: 'Crashé',
  timerTextWait: "S'il vous plaît, attendez..",
  timerTextPreparingRound: 'Tour de préparation',
  timerTextLoadingRound: 'Tour de chargement',
  comingSoon: 'À venir',
  labelsProfitOnWin: 'Bénéficiez sur la victoire',
  inputsNoOfBets: 'Nombre de paris',
  inputsAuto: 'Auto',
  inputsHalf: '1/2',
  inputsDouble: '2×',
  inputsStart: 'Commencer',
  inputsCancel: 'Annuler',
  buttonsMin: 'Min.',
  buttonsMax: 'Max.',
  prediction: 'Prédiction',
  luckyNumber: 'Numéro porte-bonheur',
  multiplier: 'Multiplicateur',
  chanceToWin: 'Chance de gagner',
  bets: 'Paris',
  depositBtn: 'Dépôt',
  rollUnder: 'Rouler sous',
  symbolsX: 'x',
  symbolsPercent: '%',
  navBarTitle: 'Histoire',
  navBarMyBets: 'Mes paris',
  navBarAllBets: 'Tous les paris',
  navBarHighRollers: 'Gros joueurs',
  navBarRoundHistory: 'Histoire du tour',
  navBarTotal: 'Paris totaux',
  totalProfit: 'Bénéfice total',
  topHeaderBetId: 'Identifiant du pari',
  topHeaderUser: 'Utilisateur',
  topHeaderPayout: 'Paiement',
  topHeaderAmount: 'Montant',
  topHeaderTime: 'Temps',
  topHeaderProfit: 'Profit',
  topHeaderRoundCrashed: 'Crashé',
  topHeaderRoundEscape: '@',
  topHeaderRoundRoundHash: 'Hacher',
  topHeaderRoundBet: 'Pari',
  topHeaderRoundProfit: 'Profit',
  topHeaderRoundSignature: 'Signature',
  roundHistoryTitle: 'INFORMATIONS SUR LE JEU',
  roundHistoryDescGame: 'Jeu #',
  roundHistoryDescCrashAt: 'Crashé à :',
  roundHistoryDescDate: 'Date :',
  roundHistoryDescBetHeader: 'Pari#',
  roundHistoryTableTitlePlayer: 'JOUEUR',
  roundHistoryTableTitleBet: 'PARI',
  roundHistoryTableTitleCashedOut: 'ENCAISSÉ',
  roundHistoryTableTitleProfit: 'PROFIT',
  roundHistoryTableTitleBetId: 'ID DE PARI',
  roundHistoryMessagesNoBetHistory: "L'historique de vos paris est vide",
  placedBetsTabPlaced: 'Pari placé',
  placedBetsTabPrev: 'Pari précédent',
  placedBetsTitleUser: 'Utilisateur',
  placedBetsTitleEscape: 'Multi.x',
  placedBetsTitleBet: 'Pari',
  placedBetsTitleProfit: 'Profit',
  placedBetsTitleCashout: 'Retrait',
  placedBetsNoPlacedBet: 'Aucun pari placé.',
  provablyFairContentCheckBtn: 'Chèque Prouvable Juste',
  provablyFairContentTitle: 'Prouvablement juste',
  provablyFairContentDesc: 'Le résultat de l’avancée à quatre côtés peut s’avérer équitable. ',
  provablyFairContentInputFieldsCrashRateTitle: "Taux d'accidents",
  provablyFairContentInputFieldsCrashRatePlaceHolder: 'Taux de crash sans x',
  provablyFairContentInputFieldsRoundHashTitle: 'Hachage rond',
  provablyFairContentInputFieldsRoundHashPlaceHolder: 'par ex. ',
  provablyFairContentInputFieldsSubmitBtn: 'Générer une signature',
  provablyFairContentSignature: 'Signature ronde',
  provablyFairContentErrorsCrashRate: 'veuillez saisir le numéro dans le champ Taux de crash',
  gameVerifyGameHeading: 'Vérifier le jeu',
  notFoundDataMessage: 'Aucune donnée trouvée',
  resetPasswordTitle: 'Réinitialiser le mot de passe',
  resetPasswordNewPasswordTitle: 'Nouveau mot de passe',
  resetPasswordNewPasswordErrorsRequired: '*un mot de passe est requis.',
  resetPasswordNewPasswordErrorsMinLength: 'Minimum de 8 caractères autorisés.',
  resetPasswordNewPasswordErrorsMaxLength: 'Maximum 16 caractères autorisés.',
  resetPasswordNewPasswordErrorsPattern: '*Le mot de passe doit comporter entre 8 et 16 caractères alphanumériques et spéciaux. ',
  resetPasswordConfirmPasswordTitle: 'Confirmez le mot de passe',
  resetPasswordConfirmPasswordErrorsNotMatched: 'Les mots de passe ne correspondent pas.',
  resetPasswordResetBtn: 'Réinitialiser',
  resetAllBtn: 'Tout réinitialiser',
  passwordResetSuccess: 'Le mot de passe a été modifié avec succès.',
  resetPasswordWentWrong: "Quelque chose s'est mal passé !",
  levelGrand: 'GRANDIOSE',
  levelMajor: 'MAJEUR',
  levelMinor: 'MINEURE',
  levelMini: 'MINI',
  bannerContentWinDaily: 'Gagnez quotidiennement 1 000 $ ',
  bannerContentContest: 'Concours maintenant ',
  bannerContentjoin: 'Rejoignez notre concours de paris quotidien et devenez le héros !  ',
  bannerContentPlayNow: 'Jouez maintenant',
  bannerContentTitle: 'Gagnez le gros lot',
  bannerContentContent: 'Jouez à de plus en plus de jeux et courez la chance de gagner le jackpot. ',
  bannerContentGameName: 'JEU CRASH',
  bannerContentGameDesc: 'Jouez à de plus en plus de jeux et courez la chance de gagner. ',
  partners: 'Partenaires',
  gamesGoldenDragon: "Dragon d'Or",
  gamesCrashGame: 'Jeu de crash',
  subCrashGameTitle: 'CrashGame',
  gamesDice: 'Dés',
  gamesHilo: 'Hilo',
  allBetsTitle: 'Tous les paris',
  allBetsBetId: 'Identifiant du pari',
  allBetsUser: 'Utilisateur',
  allBetsPayout: 'Paiement',
  allBetsAmount: 'Montant',
  allBetsTime: 'Temps',
  allBetsProfit: 'Profit',
  LoginwithOtp: 'Connectez-vous avec OTP',
  EnterLoginOtp: 'Entrez la connexion OTP',
  submit: 'Soumettre',
  footerAboutUs: 'À propos de nous',
  copyRights: 'Tous droits réservés',
  gameFooterLicenseText: '  Moolah Hub est agréé par le BCLB (Betting Control Licensing Board of Kenya) en vertu de la loi sur les paris, les loteries et les jeux, Cap 131, des lois du Kenya sous le numéro de licence : 0000610 et PG 0000348.',
  footerFaq: 'FAQ',
  footerSitePolicy: 'Politique du site',
  footerResponsibleGambling: 'Jeu responsable',
  footerTerms: 'Termes et conditions',
  footerCopywrite: 'LIGNE CRYPTO 2022. ',
  signinTitle: 'Se connecter',
  signinUsername: "Nom d'utilisateur / E-mail",
  signinPassword: 'Mot de passe',
  signinLoginBtn: 'Se connecter',
  signinSignup: "S'inscrire!",
  signinForgetPassword: 'Mot de passe oublié ?',
  signinDontHaveAccount: "Vous n'avez pas de compte ? ",
  signinCreateAccount: 'Créer un compte',
  signinLoginDescription: 'Moola Hub Gaming peut occasionnellement vous envoyer des offres gratuites et des promotions spéciales par e-mail ou SMS. ',
  signinErrorsUserNameRequired: "*Veuillez saisir votre nom d'utilisateur/e-mail.",
  signinErrorsUserNameMinLength: 'Minimum de 4 caractères autorisés.',
  signinErrorsUserNameMaxLength: 'Maximum 20 caractères autorisés.',
  signinErrorsUserNamePattern: "Veuillez saisir un nom d'utilisateur valide, seuls les lettres et les chiffres sont autorisés.",
  signinErrorsPasswordRequired: '*Un mot de passe est requis.',
  signinErrorsPasswordMinLength: 'Minimum de 8 caractères autorisés.',
  signinErrorsPasswordMaxLength: 'Maximum 16 caractères autorisés.',
  signinErrorsPasswordPattern: '*Le mot de passe doit comporter entre 8 et 16 caractères alphanumériques et spéciaux. ',
  signinSuccessfullyLoggedIn: 'Connecté avec succès.',
  signinResetMailSent: 'E-mail de réinitialisation du mot de passe envoyé.',
  signinTryAgain: "Quelque chose s'est mal passé ! Veuillez réessayer.",
  signinResetPasswordUsernameErr: "Veuillez saisir votre nom d'utilisateur/e-mail pour réinitialiser le mot de passe.",
  signinResetMailSentSuccessContent: 'Nous vous avons envoyé un lien de réinitialisation du mot de passe sur votre e-mail. ',
  signupTitle: 'Registre',
  signupUsername: "Nom d'utilisateur",
  signupEmail: 'E-mail',
  signupTermsConditions: 'Conditions générales',
  signupWalletConnect: 'Connectez-vous avec Wallet ',
  signupPassword: 'Mot de passe',
  signupEighteenPlus: "J'ai plus de 18 ans et j'accepte les conditions d'utilisation",
  signupRegisterBtn: "S'inscrire",
  signupCreateNewAccount: 'Créer un nouveau compte',
  signupFullName: 'Nom et prénom',
  signupReferralCode: 'Code de référence',
  signupConfirmPassword: 'Confirmez le mot de passe',
  signupUseSocialAccount: 'Ou utilisez un compte social',
  signupFacebook: ' Facebook',
  signupGoogle: ' Google',
  signupHaveAccount: 'Vous avez un compte ? ',
  signupLoginBtn: 'Se connecter',
  signupErrorsUserNameRequired: "*Veuillez saisir votre nom d'utilisateur.",
  signupErrorsUserNameMinLength: 'Minimum de 4 caractères autorisés.',
  signupErrorsUserNameMaxLength: 'Maximum 20 caractères autorisés.',
  signupErrorsUserNamePattern: "Veuillez saisir un nom d'utilisateur valide, seuls les lettres et les chiffres sont autorisés.",
  signupErrorsFullNameRequired: '*Veuillez entrer votre nom complet.',
  signupErrorsFullNamePattern: 'Veuillez saisir un nom complet valide, seuls les lettres et les chiffres sont autorisés.',
  signupErrorsEmailRequired: '*Veuillez saisir votre adresse e-mail.',
  signupErrorsPhoneRequired: '*Veuillez entrer votre numéro de téléphone.',
  signupErrorsEmailMinLength: 'Minimum de 4 caractères autorisés.',
  signupErrorsEmailMaxLength: 'Maximum 20 caractères autorisés.',
  signupErrorsEmailPattern: 'Veuillez saisir une adresse e-mail valide.',
  signupErrorsPasswordRequired: '*Un mot de passe est requis.',
  signupErrorsPasswordMinLength: 'Minimum de 8 caractères autorisés.',
  signupErrorsPasswordMaxLength: 'Maximum 16 caractères autorisés.',
  signupErrorsPasswordPattern: '*Le mot de passe doit contenir de 8 à 16 caractères alphanumériques (majuscules et minuscules) et des caractères spéciaux. ',
  signupErrorsConfirmPasswordMatch: 'Le mot de passe doit correspondre.',
  signupPlaceholderUserName: 'Min. ',
  signupPlaceholderEmail: 'par ex. ',
  signupPlaceholderPassword: 'Min. ',
  signupSomethingWentWrong: "Quelque chose s'est mal passé !",
  signupSignupGoogle: 'Inscrivez-vous avec succès auprès de Google.',
  signupRegistered: 'Inscrit avec succès.',
  signupConfirmAge: 'Veuillez confirmer que vous avez 18 ans.',
  signupSignupFacebook: 'Inscrivez-vous avec succès sur Facebook.',
  signupCookiesConsent: 'Veuillez autoriser les cookies tiers dans les paramètres de votre navigateur à utiliser la connexion sociale.',
  signupRegisterEmailPopupContent: 'Nous vous avons envoyé un e-mail de vérification. ',
  accountMenuDeposit: 'Dépôt',
  accountMenuCashout: 'Retrait',
  accountMenujackpotWinners: 'Gagnants du gros lot',
  accountMenuTransactions: 'Transactions',
  accountMenuPromotions: 'Promotions',
  accountMenuProfile: 'Profil',
  accountMenuLogout: 'Déconnexion',
  accountMenuSound: 'Son',
  accountMenuMusic: 'Musique',
  accountMenuWithdraw: 'Retirer',
  pageNotFound: 'Nous ne trouvons pas la page que vous recherchez !',
  error: 'Erreur',
  somethingWentWrong: "Quelque chose s'est mal passé !",
  verifyEmailThankYou: 'Merci!',
  verifyEmailEmailIsVerified: 'Votre email est vérifié.',
  verifyEmailGoToLogin: 'Aller à la page de connexion',
  verifyEmailWentWrong: "Quelque chose s'est mal passé !",
  verifyEmailTokenExpired: 'E-mail déjà vérifié ou lien expiré',
  verifyEmailGoToHome: "Aller à la page d'accueil",
  verifyEmailSuccessMsg: 'E-mail vérifié avec succès.',
  gameCardTitle: 'Moola Hub Gaming Site de jeu de crypto-monnaie prouvé équitable',
  bonusSectionTitle: 'Moola Hub JEU',
  bonusSectionSpanText: 'présente les plus généreux et variés',
  bonusSectionBonuses: 'Bonus',
  bonusSectionSubtitleText: 'Jouez avec plaisir et obtenez des récompenses supplémentaires pendant le jeu. ',
  bonusSectionHeadingText: 'Bonus de Moola Hub Gaming',
  bonusSectionDesc: "En tant que meilleur casino Bitcoin, Moola Hub Gaming dispose d'un système élaboré de bonus généreux. ",
  JoiningBonusTitle: "Bonus d'adhésion",
  JoiningBonusButton: 'Réclamez maintenant',
  JoiningBonusDesc: 'De tels bonus encouragent les joueurs de casino en ligne à jouer en utilisant Bitcoin ou d’autres cryptos. ',
  depositBonusTitle: 'Bonus de dépôt',
  depositBonusButton: 'Dépôt',
  depositBonusDesc: 'De tels bonus encouragent les joueurs de casino en ligne à jouer en utilisant Bitcoin ou d’autres cryptos. ',
  refferBonusTitle: 'Bonus de parrainage',
  refferBonusButton: 'Dépôt',
  refferBonusDesc: 'De tels bonus encouragent les joueurs de casino en ligne à jouer en utilisant Bitcoin ou d’autres cryptos. ',
  aboutSectionTitle: "Qu'est-ce que Moola Hub Gaming ?",
  aboutSectionSpanText1: " Moola Hub Gaming est un site de casino Bitcoin innovant, créé avec de nouveaux concepts de jeu en ligne à l'esprit. ",
  aboutSectionSpanText2: 'Le casino en ligne vous permet de jouer à vos jeux préférés gratuitement ou en crypto-monnaie. ',
  aboutSectionSpanText3: ' Dans ce monde virtuel du jeu Bitcoin, vous pouvez profiter de nombreuses opportunités : jouer à vos jeux de casino préférés, obtenir des bonus, participer à des concours et des promotions.',
  verifiedSectionTitle: 'Logiciel vérifié et sous licence',
  verifiedSectionSpanText1: 'Nous ne copions ni n’adoptons de logiciels provenant d’autres sites Web. ',
  faqSectionTitle: 'FAQ des joueurs',
  faqSectionForgetPasswordTitle: "J'ai oublié mon mot de passe.",
  faqSectionForgetPasswordDesc: "Vous n'avez pas fourni d'adresse e-mail de récupération pour votre compte. ",
  faqSectionMyDepositCreditedTitle: "Mon dépôt n'a pas été crédité.",
  faqSectionMyDepositCreditedDesc: " Contenu d'espace réservé pour cet accordéon, destiné à démontrer la classe. ",
  SupportedCurrencyTitle: 'Devise prise en charge',
  SupportedCurrencySpanText1: 'Nous ne copions ni n’adoptons de logiciels provenant d’autres sites Web. ',
  CarouselSectionTitle: 'CRASH HODL',
  CarouselSectionSubTitle: ' Jouez à plus de jeux et courez la chance de gagner. ',
  WalletSettingTitle: 'Paramètres du portefeuille',
  WalletSettingHideZero: 'Masquer les soldes nuls',
  WalletSettingHideZeroInfo: 'Votre solde nul n’apparaîtra pas dans votre portefeuille',
  WalletSettingDisplayFiat: 'Afficher la crypto en fiat',
  WalletSettingDisplayFiatInfo: "Tous les paris et transactions seront réglés dans l'équivalent crypto",
  WalletSettingNoteForApprox: "Veuillez noter qu'il s'agit d'estimations de devises.",
  WalletSettingSave: 'Sauvegarder',
  WalletSettingNoWalletFound: 'Aucun portefeuille trouvé',
  jackpotWinnersNoWinnerAvailable: 'Aucun gagnant disponible',
  jackpotWinnersNew: 'Nouveau',
  jackpotWinnersHeader: 'Gagnant du gros lot',
  jackpotDetailsHeader: 'Détails du jackpot',
  jackpotDetailsCampaignPeriod: 'Période de campagne',
  jackpotDetailsFrom: 'Depuis',
  jackpotDetailsTo: 'À',
  jackpotDetailsBettingRule: 'Règle de pari',
  jackpotDetailsMinBetAmount: 'Montant minimum de la mise',
  jackpotDetailsMaxBetAmount: 'Montant maximum de la mise',
  jackpotDetailsBetPercentage: 'Pourcentage de pari',
  jackpotDetailsWinningRuleHeader: 'Règle gagnante',
  jackpotDetailsWinningRule: 'Placer des paris avec un montant plus élevé augmentera les chances de gagner.',
  jackpotDetailsProfitRule: 'Si le montant de la mise est compris entre minBetAmount et maxBetAmount, alors betPercentage% du montant de la mise sera ajouté au montant du jackpot.',
  profileTitle: 'Détails personnels',
  profileFName: 'Prénom',
  profileLname: 'Nom de famille',
  profileUserName: "Nom d'utilisateur",
  profileDob: 'Date de naissance',
  profileEmail: 'Adresse email',
  profilePhone: 'Numéro de téléphone',
  profileChange: 'Changement',
  profileSave: 'Enregistrer la modification',
  profilePassword: 'Mot de passe',
  profileSubmit: 'Soumettre',
  phoneNumberPLaceHolderText: 'Entrez votre numéro de téléphone',
  profileUploadProfile: 'Télécharger une photo',
  profileCurrentPassword: 'Mot de passe actuel',
  profileNewPassword: 'Nouveau mot de passe',
  profileConfirmPassword: 'Confirmez le mot de passe',
  profileScanQRCode: 'Scanner le code QR',
  profileEnterSecretCode: 'Entrez le code secret',
  profileErrorsFirstNameRequired: 'Le prénom est obligatoire.',
  profileErrorsFirstNamePattern: 'Veuillez saisir un nom valide.',
  profileErrorsFirstNameMinLength: 'Minimum 3 caractères autorisés.',
  profileErrorsFirstNameMaxLength: 'Maximum 20 caractères autorisés.',
  profileErrorsLastNameRequired: 'Le nom de famille est obligatoire.',
  profileErrorsLastNamePattern: 'Veuillez entrer un nom valide.',
  profileErrorsLastNameMinLength: 'Minimum 3 caractères autorisés.',
  profileErrorsLastNameMaxLength: 'Maximum 20 caractères autorisés.',
  profileErrorsChangePasswordOldRequired: "L'ancien mot de passe est requis.",
  profileErrorsChangePasswordOldPattern: 'Veuillez entrer un mot de passe valide.',
  profileErrorsChangePasswordOldMinLength: 'Minimum de 8 caractères autorisés.',
  profileErrorsChangePasswordOldMaxLength: 'Maximum 16 caractères autorisés.',
  profileErrorsChangePasswordNewRequired: 'Un nouveau mot de passe est requis.',
  profileErrorsChangePasswordNewPattern: 'Veuillez saisir un mot de passe valide.',
  profileErrorsChangePasswordNewMinLength: 'Minimum de 8 caractères autorisés.',
  profileErrorsChangePasswordNewMaxLength: 'Maximum 16 caractères autorisés.',
  profileErrorsChangePasswordNewPasswordNotMatched: 'Les mots de passe ne correspondent pas.',
  profileErrorsChangePasswordNewPasswordMatched: 'Le nouveau mot de passe ne peut pas être identique au mot de passe actuel.',
  profileErrorsChangePasswordNewRequiredConfirmPass: 'Confirmer que le mot de passe est requis.',
  profileErrorsUserNameRequired: "Le nom d'utilisateur est requis.",
  profileErrorsUserNamePattern: 'Veuillez entrer un nom valide.',
  profileErrorsUserNameMinLength: 'Minimum 3 caractères autorisés.',
  profileErrorsUserNameMaxLength: 'Maximum 20 caractères autorisés.',
  profileErrorsDobRequired: 'La date de naissance est requise.',
  profileErrorsEmailRequired: 'Un e-mail est requis.',
  profileErrorsEmailPattern: 'Veuillez saisir une adresse e-mail valide.',
  profileErrorsEmailMinLength: 'Minimum 3 caractères autorisés.',
  profileErrorsEmailMaxLength: 'Maximum 20 caractères autorisés.',
  profileMessagesProfileUpdate: 'Profil mis à jour avec succès.',
  profileMessagesChangePassword: 'Mot de passe mis à jour avec succès.',
  profileProfilePicProfilePicUpload: 'Télécharger une image de profil',
  profileNoNewChanges: 'Impossible de mettre à jour le profil ! ',
  profileLoggedInWithSocial: 'Vous êtes connecté avec la connexion sociale.',
  profileSideNavigatorSound: 'Son',
  profileSideNavigatorMusic: 'Musique',
  profileSideNavigatorProfile: 'Mon profil',
  profileSideNavigatorBetHistory: 'Historique des paris',
  profileSideNavigatorTransactions: 'Transactions',
  profileSideNavigatorDeposit: 'Dépôt',
  profileSideNavigatorWithdraw: 'Retirer',
  profileSideNavigatorGameLimits: 'Limites du jeu',
  profileSideNavigatorReferral: 'Référence',
  profileSideNavigatorChangePassword: 'Changer le mot de passe',
  profileSideNavigatorTermsConditions: 'Conditions générales',
  profileSideNavigatorLogOut: 'Se déconnecter',
  profileSideNavigatorProvablyFair: 'Prouvablement juste',
  WalletInfoSectionNotAvailable: 'Pas disponible',
  WalletInfoSectionRealBalance: 'Solde réel',
  GameLimitsMinimumBet: 'Pari minimum',
  GameLimitsMaximumBet: 'Mise maximale',
  GameLimitsMaxWinFor1Bet: 'Gain maximum pour un pari',
  ProvablyFairSubTitle: 'Ce jeu utilise la technologie Provably Fair pour déterminer le résultat du jeu. ',
  ProvablyFairMaximumBet: 'Mise maximale :',
  ProvablyFairMaxWinFor1Bet: 'Gain maximum pour un pari',
  promotionsTitle: 'Promotions',
  promotionsNoLosingData: 'Désolé, promotions de bonus sans perte disponibles pour ',
  promotionsNoDepositData: 'Désolé, promotions de bonus sans dépôt disponibles pour ',
  promotionsCurrency: ' devise.',
  promotionsViewBtn: 'Voir',
  promotionsClaimSuccess: 'Vous avez réclamé avec succès',
  promotionsAvailability: 'Disponibilité: ',
  promotionsAvailabilityTabLosing: 'Perdre le bonus',
  promotionsAvailabilityTabDeposit: 'Bonus de dépôt',
  promotionsDepositBonusTableCode: 'Code',
  promotionsDepositBonusTableMinDeposit: 'Min. ',
  promotionsDepositBonusTablePercentage: 'Pourcentage',
  promotionsDepositBonusTableMaxBonus: 'Bonus maximum',
  promotionsDepositBonusTableRolloverMultipler: 'Multiplicateur de roulement',
  promotionsDepositBonusTableMaxRolloverPerBet: 'Rollover maximum par pari',
  promotionsDepositBonusTableTimeToAchieveRolloverTarget: "Il est temps d'atteindre l'objectif de refinancement",
  promotionsBonusCode: 'CODE BONUS : ',
  promotionsLossesClaim: 'Les pertes peuvent être réclamées (pendant la période de campagne) : ',
  promotionsLossesClaimLosingBonusTablePercentage: 'Pourcentage',
  promotionsLossesClaimLosingBonusTableMinLosingAmount: 'Min. ',
  promotionsBonusStatus: 'Statut bonus : ',
  promotionsBonusAmount: 'Montant du bonus : ',
  promotionsRolloverTarget: 'Objectif de rollover : ',
  promotionsRolloverAchieved: 'Rollover réalisé : ',
  promotionsActivatebtn: 'ACTIVER',
  promotionsClaimBtn: 'RÉCLAMER',
  promotionsCancelBtn: 'ANNULER',
  promotionsBackBtn: 'DOS',
  promotionsBonus: 'Prime',
  promotionsTermAndConditions: ' Conditions générales',
  promotionsClaimDepositBonusTitle: 'Étapes pour réclamer le bonus de dépôt',
  promotionsClaimDepositBonusFirst: 'Activer le code bonus',
  promotionsClaimDepositBonusSecond: 'Montant du dépôt sur le portefeuille',
  promotionsClaimDepositBonusThird: "Atteindre l'objectif de roulement pour réclamer le bonus",
  promotionsClaimLosingBonusTitle: 'Étapes pour réclamer le bonus de perte',
  promotionsClaimLosingBonusFirst: 'Activer le code bonus',
  promotionsClaimLosingBonusSecond: 'Jouez à vos jeux préférés',
  promotionsClaimLosingBonusThird: 'Cliquez sur « Réclamation des pertes » pour réclamer les pertes pendant la période de campagne.',
  promotionsWentWrong: "Quelque chose s'est mal passé !",
  transactionTitle: 'Transactions',
  transactionBetId: 'Identifiant du pari',
  transactionUser: 'Utilisateur',
  transactionPayout: 'Paiement',
  transactionAmount: 'Montant',
  transactionTime: 'Date',
  transactionProfit: 'Profit',
  transactionCashout: 'Retrait',
  transactionBet: 'Pari',
  transactionMultix: 'Multi.x',
  transactionWin: 'Gagner',
  transactionFairness: 'Justice',
  transactionReferFriend: 'Parrainez un ami',
  transactionTotal: 'Paris totaux',
  transactionWins: 'Victoires',
  transactionRefresh: 'Rafraîchir',
  transactionFilterTopMultipliers: 'Meilleurs multiplicateurs',
  transactionFilterHugeWins: 'Des gains énormes',
  transactionFilterBiggestWins: 'Les plus gros gains',
  transactionFilterMultipliers: 'Multiplicateurs',
  transactionRealBalance: 'Solde réel',
  depositWithdrawTXDate: 'Date',
  depositWithdrawTXAmount: 'Montant',
  depositWithdrawTXTxId: 'ID de transmission',
  depositWithdrawTXTxType: "Type d'opération",
  depositWithdrawTXStatus: 'Statut',
  depositWithdrawTXNoData: 'Aucune donnée disponible.',
  depositTitle: 'Dépôt',
  depositSubTitle: "L'utilisateur ne peut pas déposer ou retirer de monnaie fiduciaire. ",
  depositCopyNotSupported: 'Votre navigateur ne prend pas en charge la copie automatique dans le presse-papiers.',
  depositCopied: 'Adresse copiée.',
  depositAddressCreated: 'Adresse créée avec succès.',
  depositGenerateAddress: 'Générer une adresse',
  depositWarningText: 'Veuillez NE PAS déposer via un transfert inter-chaînes',
  withdrawTitle: 'Retirer',
  withdrawSubTitle: "L'utilisateur ne peut pas déposer ou retirer de monnaie fiduciaire. ",
  withdrawNoteDesc: "Veuillez vous assurer de NE PAS saisir l'adresse BEP2, BEP20 (BSC) comme portefeuille d'adresses de retrait LTC.",
  withdrawNoteSublist: ' Veuillez NE PAS retirer en tant que transfert inter-chaînes',
  withdrawWithdrawBtn: 'Demande de retrait',
  withdrawFees: 'Frais de retrait {{fees}} {{token}}',
  withdrawWithdrawPending: 'Votre demande de retrait est en attente. ',
  withdrawEnterFields: "Entrez le montant du retrait et l'adresse de votre portefeuille.",
  withdrawSelectWallet: 'Veuillez sélectionner le portefeuille à retirer.',
  withdrawAmountFieldTitle: 'Montant (Min. 0,03 {{wallet.currency.code}})',
  withdrawAmountFieldPlaceholder: '0',
  withdrawAddressFieldTitle: 'Ton {{wallet.currency.code}} adresse',
  withdrawAddressFieldPlaceholder: 'Tapez votre adresse',
  withdrawNoBalance: "Pas assez d'équilibre.",
  withdrawMinAmount: 'Veuillez saisir un montant supérieur ou égal à {{min}} .',
  fiatCurrencyInfo: "L'utilisateur ne peut pas déposer ou retirer de monnaie fiduciaire. ",
  paginationNextBtn: 'Suivant',
  paginationPrevBtn: 'Précédent',
  wentWrong: "Quelque chose s'est mal passé.",
  referralTitle: 'Référence',
  referralSubTitle: 'Parrainez vos amis',
  referralEarn: ' Gagnez 150 ₹ chacun',
  referralReferAndEarn: 'Parrainez et gagnez un bonus pour chaque parrainage',
  referralReferPara: " Si vous référez ce code à n'importe quel utilisateur et inscription d'utilisateur avec votre code de parrainage, vous obtiendrez un bonus de 100 % sur votre compte.",
  referralReferLink: 'Lien de référence',
  referralCopyReferralCode: 'Copier le code de référence',
  referralTotalRewards: 'Récompense totale',
  TwoWayAuthentication: 'Authentification bidirectionnelle',
  LoginRequired: 'Connexion requise !',
  BetPlacedSuccessfully: 'Pari placé avec succès',
  BetAddedInQueueSuccessfully: "Pari ajouté dans la file d'attente avec succès",
  BetRemovedFromQueueSuccessfully: "Pari supprimé de la file d'attente avec succès",
  BetCancelledSuccessfully: 'Pari annulé avec succès',
  PlayerEscapedSuccessfully: "Le joueur s'est échappé avec succès",
  CopiedSuccessfull: 'Copié avec succès',
  NotEnoughBalance: "Pas assez d'équilibre",
  AutoBetStarted: 'Pari automatique commencé ',
  AutoBetFinished: 'Pari automatique terminé ',
  IdCopied: 'Identifiant copié',
  usersConsent: 'En accédant à ce site, je confirme avoir 18 ans, et avoir révisé,',
  termsOfService: "Conditions d'utilisation",
  email: 'E-mail',
  playNow: 'Jouez maintenant',
  orContinueWith: 'Ou continuez avec',
  metamaskExtensionNotAvailable: "Veuillez installer l'extension metaMask et actualiser la page.",
  cashier: 'CAISSIER',
  account: 'COMPTE',
  hello: 'Bonjour',
  balance: 'Équilibre',
  referrals: 'Références',
  settings: 'Paramètres',
  withdrawals: 'Retraits',
  demoWallet: 'Portefeuille démo',
  myAccount: 'Mon compte',
  wallet: 'Portefeuille',
  user: 'Utilisateur',
  USD: 'USD',
  amountIsRequired: 'Le montant est requis',
  minDepositAmount: 'Le montant du dépôt doit être supérieur à {{min}}.',
  maxDepositAmount: 'Le montant du dépôt doit être inférieur à {{max}}.',
  minWithdrawAmount: 'Le montant du retrait doit être supérieur à {{min}}',
  withdrawMustLessThanWallet: 'Le montant du retrait doit être inférieur au montant de votre portefeuille',
  accountTypeIsRequired: 'Le type de compte est requis.',
  mobileNumberLength: 'Le numéro de portable doit être du {{length}} chiffres',
  phoneIsRequired: 'Le téléphone est requis',
  cpfError: 'Le CPF doit être de {{length}} personnages',
  cpfRequiredError: 'Le CPF est obligatoire',
  cnpjError: 'Le CNPJ doit être de {{length}} personnages',
  mainMenu: 'MENU PRINCIPAL',
  casino: 'Casino',
  sports: 'Sportif',
  crypto: 'Cryptomonnaie',
  NFT: 'NFT',
  poker: 'Poker',
  earnRewards: 'GAGNEZ DES RÉCOMPENSES',
  rankUp: 'Monter en rang',
  inviteFriends: 'Inviter des amis',
  partnerProgram: 'Programme de partenariat',
  home: 'Maison',
  sportsbook: 'Paris sportifs',
  menu: 'Menu',
  liveBets: 'PARIS EN DIRECT',
  allBets: 'Tous les paris',
  highRollers: 'Gros joueurs',
  luckyBets: 'Paris chanceux',
  trade: 'Commerce',
  game: 'JEU',
  player: 'JOUEUR',
  time: 'TEMPS',
  wager: 'PARI',
  multiplierBan: 'MULTIPLICATEUR',
  payoutText: 'PAIEMENT',
  bannerHeadOne: "Faites l'expérience d'une véritable innovation avec le plus haut niveau",
  bannerHeadTwo: 'programme de récompenses au sein de l’industrie.',
  registerNow: 'Inscrivez-vous maintenant',
  liveWins: 'GAINS EN DIRECT',
  monthlyStatus: 'M.',
  weeklyStatus: 'W',
  dailyStatus: 'D',
  clutchEcosystem: 'Écosystème Moola Hub',
  allGames: 'Tous les jeux',
  allSports: 'Tous les sports',
  cryptoFutures: 'contrats à terme sur les cryptomonnaies',
  tradeNow: 'Échangez maintenant',
  $clutch: 'Centre $Moola',
  allTables: 'Tous les tableaux',
  nft: 'NFT',
  viewAll: 'Tout afficher',
  rewards: 'RÉCOMPENSES',
  profile: 'Profil',
  clutchProfile: 'PROFIL du Moola Hub',
  totalBets: 'Paris totaux',
  totalWagered: 'Total misé',
  joinDate: "Date d'adhésion",
  displaySocialLinks: 'Afficher les comptes sociaux liés',
  privateProfile: 'Profil privé',
  rank: 'Rang',
  nextRank: 'Rang suivant',
  changeUsername: "Changer le nom d'utilisateur",
  newPassword: 'Nouveau mot de passe',
  changeName: 'Changer de nom',
  linkSocialAccount: 'Associer un compte social',
  privateProfileTooltip: "Après avoir rendu votre profil privé, les autres utilisateurs ne verront pas votre nom d'utilisateur à côté des paris, des courses, etc.",
  socialLinksTooltip: 'Contenu non disponible',
  rankTooltip: 'Contenu non disponible',
  balances: 'soldes',
  createReferralBalance: 'Créer un solde de référence',
  total: 'Total',
  switchBalance: 'Changer de solde',
  mainAccount: 'Compte principal',
  tips: 'Conseils',
  receivedAmount: 'Montant reçu',
  dateOrTime: 'Date/Heure',
  view: 'Voir',
  allChains: 'Toutes les chaînes',
  creditAmount: 'Montant du crédit',
  setCustomReferralCode: 'Définir un code de référence personnalisé',
  changeEmail: "Changer d'e-mail",
  newEmail: 'Nouvel e-mail',
  createPassword: 'Créer un mot de passe',
  newUsername: "Nouveau nom d'utilisateur",
  username: "Nom d'utilisateur",
  changePassword: 'Changer le mot de passe',
  twoFactorAuthentication: 'authentification à deux facteurs',
  twoFactorAuthenticationTitle: "L'utilisation de l'authentification à deux facteurs est fortement recommandée car elle protège votre compte à la fois avec votre mot de passe et votre téléphone.",
  twoFactorAuthenticationSubTitle: 'Un e-mail et un mot de passe doivent être définis pour activer 2FA. ',
  enable2fa: 'ACTIVER 2FA',
  verifyIdentityByKyc: 'Vérifiez votre identité (kyc)',
  oldPassword: 'Ancien mot de passe',
  live: 'En direct',
  soccer: 'Football',
  tennis: 'Tennis',
  fifa: 'FIFA',
  basketball: 'Basket-ball',
  iceHockey: 'Hokey sur glace',
  volleyball: 'Volley-ball',
  tableTennis: 'Tennis de table',
  baseball: 'Base-ball',
  rubgy: 'Rugby',
  golf: 'Golf',
  boxing: 'Boxe',
  myBets: 'Mes paris',
  favourites: 'Favoris',
  americanFootball: 'Football américain',
  buyCrypto: 'Acheter des cryptomonnaies',
  oldEmail: 'Ancien e-mail',
  loggedInSuccess: 'Connecté avec succès',
  loggedOutSuccess: 'Déconnecté avec succès',
  signup: "L'utilisateur s'est inscrit avec succès",
  tokenVerify: 'Le jeton a été envoyé à votre e-mail, veuillez vérifier',
  emailVerify: "L'e-mail a été vérifié",
  emailChangedSuccess: "L'e-mail a été modifié avec succès",
  profileUpdatedSuccess: 'Profil mis à jour',
  otpVerified: 'OTP vérifié',
  twoFADeactivated: 'Authentification 2FA désactivée',
  internalServerError: 'Erreur interne du serveur',
  unAuthorized: 'Non autorisé',
  dataNotFound: 'Données introuvables',
  setReferralCode: 'Définir le code de parrainage...',
  ultimate: 'ULTIME',
  notFound: 'Introuvable',
  originals: 'Originaux MH',
  casinoTransactions: 'Transactions de casino',
  clutchOriginals: 'Moola Hub Originaux',
  sportsbookTransactions: 'Transactions de paris sportifs',
  status: 'Statut',
  success: 'Succès',
  failed: 'Échoué',
  pending: 'En attente',
  date: 'Date',
  to: 'À',
  gameName: 'Nom du jeu',
  eventId: "ID d'événement",
  transactionId: 'Identifiant de transaction',
  roundId: 'ID de ronde',
  bet: 'Pari',
  win: 'Gagner',
  transactionType: 'Type de transaction',
  at: 'à',
  downloadAll: 'Télécharger tout',
  gameText: 'Jeu',
  betId: 'Identifiant du pari',
  gameId: 'Identifiant du jeu',
  actionType: "Type d'action",
  searchGames: 'Rechercher des jeux',
  provider: 'Fournisseur',
  search: 'Recherche',
  all: 'Tous',
  sortBy: 'Trier par',
  popular: 'Populaire',
  challengePool: 'Pool de défis',
  loadMore: 'Charger plus',
  showMore: 'Afficher plus',
  bitcoin: 'Bitcoin',
  btc: 'BTC',
  chat: 'Chat',
  trades: 'Métiers',
  battles: 'Batailles',
  loginToChat: 'Connectez-vous pour discuter',
  rules: 'Règles',
  send: 'Envoyer',
  expand: 'Développer',
  signIn: 'Se connecter',
  cross: 'Croix',
  collapse: 'Effondrement',
  emailPlaceholder: 'votre email@domain.com',
  removeFromFavourite: 'Supprimer des favoris',
  addToFavourite: 'Ajouter aux favoris',
  verify: 'Vérifier',
  change: 'Changement',
  accountVerification: 'Vérification du compte',
  gamesNotFound: 'Jeux introuvables',
  recentlyPlayed: 'Joué récemment',
  moreFrom: 'Plus de',
  demoMode: 'Mode Démo',
  providersList: 'Liste des fournisseurs',
  games: 'Jeux',
  providers: 'Fournisseurs',
  close: 'Fermer',
  joinedOn: 'Rejoint le',
  rewarded: 'Récompensé',
  favouriteGame: 'Jeu préféré',
  saySomething: 'Dire quelque chose',
  onlySendToAddress: 'Envoyez seulement {{currencyCode}} à cette adresse',
  yourAddress: 'Votre adresse',
  addressIsRequired: "L'adresse est requise",
  withdrawRequestSent: "Demande de retrait envoyée à l'administrateur, veuillez attendre l'approbation !",
  noMatchesFound: 'Aucune correspondance trouvée',
  tip: 'CONSEIL',
  sendTip: 'Envoyer un pourboire',
  minAmount: 'Le montant doit être supérieur à {{min}}',
  maxAmount: 'Le montant doit être inférieur à {{max}}',
  doNotShowTip: 'Ne pas afficher de pourboire dans le chat',
  demoAvailable: 'Démo disponible',
  denoNotAvailable: 'Démo non disponible',
  goFullscreen: 'Passer en plein écran',
  endsAt: 'Se termine à',
  inProgress: 'En cours',
  eventEnd: "Fin de l'événement",
  latestPromotions: 'Dernières promotions',
  archived: 'Archivé',
  noPromotionsFound: 'Aucune promotion trouvée',
  claim: 'Réclamer',
  add: 'Ajouter',
  viewDashboard: 'Afficher le tableau de bord',
  prize: 'Prix',
  timeLeft: 'Temps restant',
  viewTransactions: 'Afficher les transactions',
  sendAmountInCashier: "Envoyez le montant de {{currency}} de votre choix à l'adresse suivante pour recevoir l'équivalent en Coins.",
  yourPersonalDepositAddress: 'Votre personnel {{currency}} adresse de dépôt',
  copyAddress: "Copier l'adresse",
  theValueOfCurrencyMayChange: "La valeur de {{currency}} peut changer d'ici le moment où nous recevons votre paiement",
  doNotHaveAnyCurrency: "Je n'en ai pas {{currency}}?",
  depositOptions: 'Options de dépôt',
  withdrawalOptions: 'Options de retrait',
  withdrawCurrency: 'Retirer {{currency}}',
  enterAddressToReceiveFunds: "  Veuillez entrer le {{currency}} l'adresse du portefeuille sur laquelle vous souhaitez recevoir les fonds. ",
  receivingCurrencyAddress: 'Réception {{currency}} adresse',
  withdrawalAmount: 'Montant du retrait',
  pasteYourCurrencyAddressHere: 'Collez votre {{currency}} adresse du portefeuille ici...',
  requestWithdrawal: 'Demander le retrait',
  receiveTheSpecifiedAmount: '*Vous recevrez le spécifié {{currency}} montant à votre adresse de retrait',
  valueMayVary: '*La valeur soustraite de votre solde peut varier entre maintenant et le moment où nous traitons votre retrait.',
  coupons: 'Coupons',
  depositAddress: 'Dépôt {{currency}} adresse',
  updateEmail: "Mettre à jour l'e-mail",
  update: 'Mise à jour',
  loginHistory: 'Historique de connexion',
  showLoginHistory: "Afficher l'historique de connexion",
  currencyErr: "L'identifiant de la devise est requis",
  wagerErr: 'Le montant de la mise est requis',
  minWagerErr: 'Le montant minimum de la mise est de 1',
  mulValErr: 'Valeur multiplicatrice comprise entre 1 et 1 000',
  closeBetErr: 'Entrez le montant du pari final valide',
  profitErr: 'Entrez un montant de profit valide',
  multiplierErr: 'Le montant du multiplicateur est requis',
  euro: 'Euro',
  manual: 'Manuel',
  auto: 'Auto',
  pnLFee: 'Frais PnL',
  flatFee: 'Tarif forfaitaire',
  takeProfitLabel: 'PROFITEZ AU PRIX',
  closeBetLabel: 'FERMER LE PARI AU PRIX',
  priceUpLabel: 'LE PRIX VA-T-IL AUGMENTER OU DIMINUER ?',
  up: 'EN HAUT',
  down: 'VERS LE BAS',
  payoutMul: 'MULTIPLICATEUR DE PAIEMENT',
  bustPrice: 'Prix ​​​​de buste',
  safe: 'Sûr',
  wild: 'Sauvage',
  placeBet: 'Placer un pari',
  roundEnd: 'BOUTS RONDS EN',
  timerInfo: 'Tous les paris sur les montagnes russes seront clôturés et le prix sera réinitialisé à 1 000 $ chaque jour à 00h00 UTC.',
  month: 'mois',
  PNL: 'PNL',
  ROI: 'Retour sur investissement',
  roi: 'roi',
  funding: 'Financement/H',
  exitPriceLabel: 'Prix ​​de sortie',
  cashedOut: 'Encaissé',
  open: 'Ouvrir',
  chartPreferences: 'Préférences de graphique',
  yAxis: "Préférences de l'axe Y",
  additionalFeatures: 'Fonctionnalités supplémentaires',
  themes: 'Thèmes',
  locale: 'Lieu',
  changeTimezone: 'Changer le fuseau horaire',
  changeLanguage: 'Changer de langue',
  tooltip: 'Info-bulle',
  field: 'Champ',
  value: 'Valeur',
  dateTime: 'Date/Heure',
  simulator: 'simulateur',
  random: 'ALÉATOIRE',
  myMarket: 'Mon_Marché',
  marketCount: 'Amérique/Chicago',
  mountain: 'montagne',
  candle: 'bougie',
  winningAmount: 'montant gagnant',
  activeBets: 'Paris actifs',
  closedBets: 'Paris fermés',
  publicBets: 'Paris publics',
  leaderboard: 'Classement',
  howToplay: 'Comment jouer',
  rOICalculator: 'Calculateur de retour sur investissement',
  priceFormulation: 'Formulation des prix',
  howToplayPriceFormulation: 'Comment jouerFormulation des prix',
  allInstruments: 'Tous les instruments',
  week: 'Semaine',
  monthLabel: 'Mois',
  day: 'Jour',
  betLabel: 'PARI',
  entryPrice: "PRIX D'ENTRÉE",
  bustPriceLabel: 'Prix ​​​​de buste',
  multiplierLabel: 'MULTIPLICATEUR',
  exitPrice: 'PRIX DE SORTIE',
  pnl: 'P&L',
  manualType: 'manuel',
  pnlType: 'pnl',
  takeProfitAmount: 'takeProfitAmount',
  profitType: 'profit',
  stopLossAmount: 'stopLossAmount',
  stopLoss: 'arrêter la perte',
  details: 'Afficher les détails',
  profitLoss: 'Profits et pertes',
  noBalance: "Pas assez d'équilibre.",
  maxBetAmount: 'Montant maximum de la mise',
  limit: 'limite dépassée.',
  minBetAmount: 'Montant minimum de la mise',
  rollsLimitMsg: 'Le nombre de lancers doit être inférieur ou égal à 100.',
  mines: 'Mines',
  loginFailed: 'La connexion a échoué',
  noEntries: 'Aucune entrée',
  descriptionIsRequired: 'Une description est requise',
  description: 'Description',
  report: 'Rapport',
  userReportedSuccessfully: "L'utilisateur a été signalé avec succès",
  tipSendSuccessfully: 'Astuce envoyée avec succès',
  walletSettings: 'Paramètres du portefeuille',
  hideZero: 'Masquer les soldes nuls',
  hideZeroInfo: "Votre solde nul n'apparaîtra pas dans votre portefeuille",
  displayFiat: 'Afficher la crypto en fiat',
  displayFiatInfo: "Tous les paris et transactions seront réglés dans l'équivalent crypto",
  noteForApprox: "Veuillez noter qu'il s'agit d'estimations de devises.",
  save: 'Sauvegarder',
  noWalletFound: 'Aucun portefeuille trouvé',
  unableToConvert: 'Impossible de convertir',
  limits: 'Limites',
  timePeriodPlaceholder: 'Nombre de jours',
  wagerLimit: 'Limite de mise',
  lossLimit: 'Limite de perte',
  depositLimit: 'Limite de dépôt',
  takeABreak: 'Faites une pause',
  customTimePeriod: 'Période personnalisée',
  timePeriod: 'Période',
  selfExclusion: 'Auto-exclusion',
  confirm: 'Confirmer',
  setLimit: 'Définir la limite',
  removeLimit: 'Supprimer la limite',
  enterAmount: 'Entrez le montant',
  notSet: 'Non défini',
  hours: 'Heures',
  daily: 'Tous les jours',
  weekly: 'Hebdomadaire',
  monthly: 'Mensuel',
  cancel: 'Annuler',
  usedLimit: 'Limite utilisée',
  type: 'Taper',
  updatedAt: 'Mis à jour à',
  editLimit: 'Modifier la limite',
  providerSearchBarAction: 'Action',
  providerSearchBarAnotherAction: 'Une autre action',
  providerSearchBarOtherOption: "Quelque chose d'autre ici",
  paymentSectionHeading: 'Besoin de crypto ? ',
  limitRemovedMessage: 'Votre limite de suivi sera supprimée.',
  setLimitMessage: 'Vous êtes sur le point de définir la limite suivante pour votre compte. ',
  setBreakMessage: 'Vous êtes sur le point de bloquer l’accès à votre compte pendant une période prédéfinie. ',
  setSessionLimitMessage: 'Vous êtes sur le point de définir la limite suivante pour votre compte. ',
  removeSessionLimitMessage: 'Votre limite de session sera supprimée',
  notAchieved: 'pas atteint',
  flexibleRegistration: 'Inscription flexible !',
  mostPlayed: 'Les plus joués',
  badge: 'Insignes',
  allBadges: 'Tous les insignes',
  socialMedia: 'Réseaux sociaux',
  allLinks: 'Tous les liens',
  statistics: 'Statistiques',
  newMessage: 'Nouveau message',
  tipFor: 'astuce pour',
  play: 'Jouer',
  gameOn: 'Jouez !',
  betOn: 'Parier sur',
  ecosystemUnbeatableOdds: 'Pariez mieux - Accédez à des cotes imbattables sur des événements passionnants avec notre plateforme de paris de premier plan !',
  startBetting: 'Commencer à parier',
  ecosystemJoinTheFun: 'Amusez-vous - Explorez les jeux exclusifs de Moola Hub et plus de 9 000 favoris de casino !',
  futures: 'Contrats à terme',
  ecosystemTrade: "Tradez plus intelligemment, maximisez vos gains - Bénéficiez d'un effet de levier jusqu'à 1 000 x !",
  joinNow: 'Inscrivez-vous maintenant',
  clutchCoaster: 'Dessous de verre Moola Hub',
  searchCurrencies: 'Rechercher des devises',
  noNotificationsFound: 'Aucune notification trouvée',
  notifications: 'Notifications',
  lobby: "Hall d'entrée",
  rollercoaster: 'Dessous de verre Moola Hub',
  applyReferralCode: 'Appliquer le code de parrainage',
  doNotHaveReferral: "Vous n'avez pas de code ? ",
  apply: 'Appliquer',
  referralCode: 'Code de référence',
  copyCode: 'Copier le code',
  referralLink: 'Lien de parrainage',
  copyLink: 'Copier le lien',
  referralCodeCopied: 'Code de parrainage copié',
  referralLinkCopied: 'Lien de parrainage copié',
  withdrawAddressCannotBeSame: "L'adresse de retrait ne peut pas être la même que la vôtre",
  userId: "ID de l'utilisateur",
  active: 'Actif',
  inactive: 'Inactif',
  currency: 'Devise',
  hostGames: 'Héberger des jeux',
  earnCrypto: 'Gagnez de la crypto',
  inviteHostAndEarn: 'Invitez, hébergez et gagnez - Organisez vos propres événements de poker',
  startEarning: 'Commencez à gagner',
  clutch: 'Centre Moola',
  whitePaper: 'Livre blanc',
  deepDiveInto: 'Plongez profondément dans l’économie des pièces de Moola Hub',
  learnMore: 'Apprendre encore plus',
  sport: 'sport',
  vipRanked: 'Classement VIP',
  betMoreEarnMore: 'Pariez plus, gagnez plus - Maximisez votre potentiel',
  claimBonus: 'Réclamez le bonus',
  referredUserId: "Identifiant de l'utilisateur référé",
  bonusId: 'Identifiant bonus',
  bonusAmount: 'Montant du bonus',
  expiresAt: 'Expire le',
  claimedOn: 'Réclamé le',
  preview: 'Aperçu',
  upload: 'Télécharger',
  pleaseSelectImage: 'Veuillez sélectionner une image',
  imageSizeMustLessThan: "La taille de l'image doit être inférieure à {{size}} Mo",
  imageSizeFormat: 'Utilisez les formats d’image png, jpeg, jpg.',
  maxFileSize: 'Max. ',
  dragPosition: 'Faites glisser pour changer de position',
  onlyNumbers: 'Seulement des chiffres',
  cannotBeRemoved: 'Ne peut pas être supprimé',
  amountInBetween: 'Le montant doit être compris entre quotidien et mensuel (inclus)',
  amountEqualOrGreater: 'Montant égal ou supérieur à la semaine',
  amountEqualOrLess: 'Le montant doit être égal ou inférieur à celui hebdomadaire et mensuel',
  cannotBeIncreased: 'Ne peut pas être augmenté',
  enterPassword: 'Entrez le mot de passe',
  sessionLimit: 'Limite de session',
  timePeriodRequired: 'Un délai est requis',
  amountGTZero: 'Montant supérieur à zéro',
  mma: 'MMA',
  eaSportsFifa: 'fifa',
  counterStrike: 'Contre-grève',
  rugbyUnion: 'Fédération de rugby',
  valorant: 'Valorant',
  cricket: 'Cricket',
  dota: 'DOTA-2',
  rugbyLeague: 'Ligue de rugby',
  hilo: 'Hilo',
  noRewardsFound: 'Aucune récompense trouvée',
  expiredAt: 'Expire à',
  resizeErr: 'Boucle ResizeObserver terminée avec des notifications non délivrées.',
  debit: 'débit',
  credit: 'crédit',
  bonusExpired: 'Bonus expiré',
  nonCashAmount: 'Montant non monétaire',
  crash: 'Balade Moola',
  cancelBetSuccessfully: 'Pari annulé avec succès',
  start: 'Commencer',
  invalidBetAmount: "Le montant du pari n'est pas valide",
  zeroError: 'Le numéro de pari doit être supérieur à 0',
  loading: 'Chargement',
  flipCoin: 'Lancement de pièces',
  customs: 'Douane',
  redeemCode: 'ÉCHANGER LE CODE COUPON',
  couponText: 'Nous les publions régulièrement sur notre',
  copyrightText: "C'est un fait établi depuis longtemps qu'un lecteur sera distrait par le contenu lisible d'une page lorsqu'il examinera sa mise en page.",
  platform: 'Plate-forme',
  support: 'Soutien',
  faq: 'FAQ',
  partnershipProgram: 'Programme de partenariat',
  blog: 'Blogue',
  helpCenter: "Centre d'aide",
  aboutUs: 'À propos de nous',
  community: 'Communauté',
  facebook: 'Facebook',
  twitter: 'Gazouillement',
  instagram: 'Instagram',
  discord: 'Discorde',
  english: 'Anglais',
  spanish: 'Espagnol',
  french: 'Français',
  legal: 'Légal',
  moreFromClutch: 'PLUS DE Moola Hub',
  cashoutAt: 'Retrait à',
  userProfit: 'Votre bénéfice',
  crashHistory: 'Historique complet des accidents',
  crashPlayNextRoundBtn: 'Jouer (prochain tour)',
  crashCancelNextRoundBtn: 'Annuler (prochain tour)',
  crashAutoPlayBtn: 'Lecture automatique (prochain tour)',
  crashAutoStartBtn: 'Démarrer la lecture automatique',
  crashCancelAutoPlay: 'Annuler la lecture automatique',
  crashGameBetNotFound: 'Aucun pari trouvé dans ce tour en cours',
  crashPlayers: 'Joueur',
  numberOfBets: 'Nombre de paris',
  configOnWin: 'Sur la victoire',
  configOnLoss: 'En cas de perte',
  configProfitStop: 'Arrêtez-vous sur le profit',
  configLossStop: 'Arrêter en cas de perte',
  configIncreasedByBtn: 'Augmenter de',
  configAuto: 'Configurer automatiquement',
  instantBet: 'Pari instantané',
  animation: 'Animation',
  maxBet: 'Pari maximum',
  crashPointOneTimeMultiplier: 'Le point de crash minimum est au multiplicateur x1,00.',
  crashPointThousandTimeMultiplier: 'Le point de crash maximum est au multiplicateur x1 000 000,00.',
  crashPointMinOneTimeMultiplier: 'Le retrait minimum est égal au multiplicateur x1,01.',
  fairnessSeedText: 'Graines',
  fairnessActiveSeeds: 'Graine de client active',
  fairnessActiveHashedSeeds: 'Graine de serveur actif (hachée)',
  fairnessBetsPair: 'Total des mises effectuées avec paire',
  rotateSeeds: 'Rotation de la paire de graines',
  nextServerSeed: 'Graine de serveur suivante (hachée)',
  mineGameStarsCountText: 'Il reste des étoiles',
  mineGameRandomTileText: 'Choisissez une tuile au hasard',

  low: "Faible",
  medium: "Moyen",
  high: "Haut",
  rows: "Lignes",
  riskLevel: "Niveau de risque",
  cancelBetCount: "Annuler {{count}} Paris",
  startCard: "Carte de départ",
  skipCard: "Passer la carte",
  aceBeingTheLowest: "ACE étant le plus bas",
  kingBeingTheHighest: "ROI étant le plus élevé",
  higherOrSame: "Supérieur ou identique",
  lowerOrSame: "Inférieur ou identique",
  above: "Plus haut",
  below: "Inférieur",
  same: "Même",
  coefficient: "Coefficient",
  maxOddReachedPleaseCashout: "Max impair atteint, veuillez retirer.",
  gameMode: "Mode de jeu",
  chipValue: "Valeur du jeton : 1 jeton = 0,01 {{currencyCode}}",
  undo: "Défaire",
  clear: "Clair",

  autoBet: "Pari automatique",
  presets: "Préréglages",
  minHeadTail: "Min. Pile/Queue",
  pickSide: "Choisir un côté",
  coinsCount: "Nombre de pièces",

  blackJackdouble: "Double",
  hit: "Frapper",
  split: "Diviser",
  stand: "Rester",
  insurance: "Assurance?",
  acceptInsurance: "Accepter l'assurance",
  noInsurance: "Pas d'assurance",

  rounds: "Tours",
  hits: "Clics",
  pickNumbers: "Choisissez des numéros",
  playTimes: "Jouer {{value}}"
}
